<div class="day-seller-producer">
  <!-- Image -->
  <div class="bm--hover-effect bm--hover-effect--producer" routerLink="bm/{{ producer?.beatmakerId }}">
    <img loading="lazy" src="{{ producer?.images.original }}" alt="{{ producer?.beatmakerName }} avatar" />
  </div>

  <!-- Content -->
  <div class="day-seller-producer__name">
    @if (producer?.beats[0].beatmakerVerified) {
      <bmcore-verify-icon></bmcore-verify-icon>
    }
    <div>
      <a class="common-bmstv-title-1" routerLink="/bm/{{ producer?.beatmakerId }}">
        {{ producer?.beatmakerName }}
      </a>
    </div>
  </div>
  <p class="common-bmstv-title-2 common-bmstv-title-2--without-hover">Beats: {{ producer?.beatsCount }}</p>
  <!--<p>followers count: {{ producer?.followersCount }}</p>-->
</div>
